import { render, staticRenderFns } from "./groceryBagOverviewPage.vue?vue&type=template&id=0c95e39e&"
import script from "./groceryBagOverviewPage.vue?vue&type=script&lang=js&"
export * from "./groceryBagOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./groceryBagOverviewPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports